import styled from "@emotion/styled";
import {Container} from "@mui/material";

const MainStyled = styled(Container, {
    shouldForwardProp: (prop) =>
        !['isRequestpersonalDataShown', 'isLeaveDialogBlockShown', 'isSmallScreen'].includes(prop),
})(({ theme, isRequestpersonalDataShown, isLeaveDialogBlockShown, isSmallScreen }) => ({
    overflow: 'hidden',
    position: 'fixed',
    height: '100%',
    maxHeight: '600px',
    maxWidth: '360px',
    fontFamily: theme.typography.fontFamily,
    borderRadius: theme.shape.window,
    '&::before': {
        content: '""',
        position: 'absolute',
        top: !isRequestpersonalDataShown && !isLeaveDialogBlockShown ? '6px' : '0px',
        left: 0,
        width: '100%',
        height: !isRequestpersonalDataShown && !isLeaveDialogBlockShown ? '590px' : '600px',
        zIndex: -1,
        borderRadius: theme.shape.window,
        backgroundColor: theme.palette.primary.background,
    },
    ...(isSmallScreen && {
        maxHeight: '100%',
        maxWidth: '100% !important',
        borderRadius: 0,
        backgroundColor: theme.palette.primary.background,
        '&::before': {
            height: '100% !important',
            borderRadius: 0,
        },
    }),
}));

export default MainStyled;